<template>
    <tfoot class="rosterTeamFooter">
      <tr>
            <td class="footerFirstColumn font-weight-bold info lighten-4">Remaining Vol/Loc</td>
            <td v-for="(day, index) in duplicatedDays" :key="index" class="info lighten-4">
                <v-tooltip top v-if="day.IsVolume" :disabled="dayRemainingVolumeToolTips(day).length == 0">
                    <template v-slot:activator="{ on, attrs }">
                        <span :class="dayRemainingVolumeClass(day)" v-bind="attrs" v-on="on">{{ getDayRemainingVolume(day) }}</span>
                    </template>
                    <span v-for="(tip, j) in dayRemainingVolumeToolTips(day)" :key="j">
                        {{ tip }} <br>
                    </span>
                </v-tooltip>
                <v-tooltip top disabled v-else>
                    <template v-slot:activator="{ on, attrs }">
                        <span :class="dayRemainingLocationClass(day)" v-bind="attrs" v-on="on">{{ getDayRemainingLocations(day) }}</span>
                    </template>
                </v-tooltip>
            </td>

            <td class="footerLastColumn3 info lighten-4"><div class="font-weight-bold">{{getGrandTotalRosteredVolume() | thousandsSeparators}}{{uom}}</div></td>
            <td class="footerLastColumn2 info lighten-4">
                <div class="font-weight-bold">
                    <v-chip color="primary" text-color="white">
                        {{getGrandTotalRosteredLocationIDs().length}}
                    </v-chip>
                </div>
            </td>
            <td class="footerLastColumn1 info lighten-4">
                <div class="font-weight-bold">
                    <v-chip color="error" text-color="white">
                        {{getGrandTotalRDOs()}}
                    </v-chip>
                </div>
            </td>
      </tr>
      <tr v-if="showActuals">
            <td class="footerFirstColumn font-weight-bold info lighten-4">Actuals Volume</td>
            <td colspan="2" v-for="(day, index) in days" :key="index" class="info lighten-4">
                <div v-if="!day.IsPast" class="font-weight-bold vertical-cell" >
                    n/a
                </div>
                <div v-else class="font-weight-bold vertical-cell">
                     {{ getDayActualVolume(day) | thousandsSeparators}}{{uom}}
                </div>
            </td>
            <td class="footerLastColumn3 info lighten-4"></td>
            <td class="footerLastColumn2 info lighten-4"></td>
            <td class="footerLastColumn1 info lighten-4"></td>
      </tr>
      <tr>
            <td class="footerSecondColumn font-weight-bold info lighten-4">RDO's</td>
            <td colspan="2" v-for="(day, index) in days" :key="index" class="info lighten-4">
                <div class="font-weight-bold vertical-cell">
                     {{getTotalDayRDOs(day)}}
                </div>
            </td>
            <td class="footerLastColumn3 info lighten-4"></td>
            <td class="footerLastColumn2 info lighten-4"></td>
            <td class="footerLastColumn1 info lighten-4"></td> 
      </tr>      
    </tfoot>
</template>

<script>

import RosterUtilService from '@/services/rosterUtilService';
import { mapState, mapGetters } from 'vuex';

export default {
    components: {
   
    },
    props: {
        teams: {
            type: Array,
            required: false
        },
        cropLocationVarietyRosters: {
            type: Array,
            required: false
        },
        days: {
            type: Array,
            required: false
        },
        duplicatedDays: {
            type: Array,
            required: false
        }
    },
    data(){
        return {
      
        }
    },
    computed: {
        ...mapState("RosterStore", [
            "rosterTeamPlans",
            "rosterTeamPlansByTeam",
            "showActuals"
        ]),
        ...mapGetters("RosterStore", [
            "uom",
            "selectedUOMScaleFactors"
        ])
    },
    methods: {
        getTotalDayRDOs(day) {
            return RosterUtilService.getDayTotalRDOs(day, this.teams, this.rosterTeamPlans);
        },
        getDayActualVolume(day) {
            if(day.IsPast) {
                return RosterUtilService.getDayActualVolume(day, this.teams, this.rosterTeamPlans, this.selectedUOMScaleFactors);
            }
            return null;
        },
        getDayRemainingVolume(day) {
            var diff = RosterUtilService.getDayRemainingVolume(day, this.cropLocationVarietyRosters);
            if (!diff) {
                return "";
            }
            return RosterUtilService.formatThousandsSeparators(diff) + this.uom;
        },
        getDayRemainingLocations(day) {
            var diff = RosterUtilService.getDayRemainingLocations(day, this.cropLocationVarietyRosters);
            if (!diff) {
                return "";
            }
            return RosterUtilService.formatThousandsSeparators(diff);
        },
        getGrandTotalRosteredVolume() {
            return RosterUtilService.getGrandTotalRosteredVolume(this.teams, this.days, this.cropLocationVarietyRosters);
        },
        getGrandTotalRDOs() {
            return RosterUtilService.getGrandTotalRDOs(this.rosterTeamPlansByTeam);
        },
        getGrandTotalRosteredLocationIDs() {
            return RosterUtilService.getGrandTotalRosteredLocationIDs(this.cropLocationVarietyRosters)
        },
        dayRemainingVolumeClass(day) {
            var ret = "font-weight-bold vertical-cell";
            var diff = RosterUtilService.getDayRemainingVolume(day, this.cropLocationVarietyRosters);
            if(!diff || diff == 0) {
                return ret;
            }
            return ret + (diff > 0 ? " success--text" : " error--text");
        },
        dayRemainingLocationClass(day) {
            var ret = "font-weight-bold vertical-cell";
            var diff = RosterUtilService.getDayRemainingLocations(day, this.cropLocationVarietyRosters);
            if(!diff || diff == 0) {
                return ret;
            }
            return ret + (diff > 0 ? " success--text" : " error--text");
        },
        dayRemainingVolumeToolTips(day) {
            return RosterUtilService.getDayRemainingVolumeToolTips(day, this.cropLocationVarietyRosters, this.uom);
        },
    }
    
}
</script>
<style scoped>
.vertical-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.rosterTeamFooter tr td, tr th {
    position: -webkit-sticky;
    position: sticky;
    background-color: white;
    z-index: 25;
}

.rosterTeamFooter tr {
    border-top: none !important;
}
.rosterTeamFooter tr:nth-child(2) td, .rosterTeamFooter tr:nth-child(2) th {
    bottom: 0px;
    height: 25px;
    border-right: 1px solid rgba(0,0,0,0.12);
    outline: 1px solid rgba(0,0,0,0.12);

}

.rosterTeamFooter tr:nth-child(1) td, .rosterTeamFooter tr:nth-child(1) th {
    bottom: 25px;
    height: 25px;
    border-right: 1px solid rgba(0,0,0,0.12);
    outline: 1px solid rgba(0,0,0,0.12);

}

.rosterTeamFooter tr {
    height: 25px;
    border-top: none;
    border-bottom: none;
}

.footerFirstColumn {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 100!important;
    background: white;
}

.footerSecondColumn {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 100!important;
    background: white;
}

.footerLastColumn1 {
    position: -webkit-sticky;
    position: sticky;
    right: 0;
    z-index: 100!important;
    background: white;
    border: none!important;
    outline:none!important;
    min-width: 100px;
}

.footerLastColumn2 {
    position: -webkit-sticky;
    position: sticky;
    right: 100px;
    z-index: 100!important;
    background: white;
    border: none!important;
    outline:none!important;
    min-width: 100px;
}

.footerLastColumn3 {
    position: -webkit-sticky;
    position: sticky;
    right: 200px;
    z-index: 100!important;
    background: white;
    border: none!important;
    outline:none!important;
    min-width: 100px;
}

</style>